import { render } from "./ShipLastPosition.vue?vue&type=template&id=911db004&scoped=true"
import script from "./ShipLastPosition.vue?vue&type=script&lang=js"
export * from "./ShipLastPosition.vue?vue&type=script&lang=js"

import "./ShipLastPosition.vue?vue&type=style&index=0&id=911db004&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/jahajibd.com/ia.jahajibd.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-911db004"]])

export default __exports__